<div class="UL">
    <div class="UL__header">Please upload your company logo</div>

    <div class="UL__main-content">
        <div>
            <image-uploader :options="imageUploaderOptions" @change="onImageUpload" :isLoading="imageUploading"></image-uploader>
            <p class="UL__image-info"> Image size needs to be 512px in width and height. </p>
            <p class="UL__image-info"> File types: .png, .jpg </p>
        </div>
    </div>

    <div class="UL__proceed">
        <mom-button variant="raised" @click="onNext">Next / Skip</mom-button>
    </div>
</div>